
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, Chip, Popover
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set } from 'lodash';
import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA } from '../../components/form';
import moment from 'moment';
import { getFormState } from '../../../helpers/form';
import dayjs from 'dayjs';
import IosShareIcon from '@mui/icons-material/IosShare';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ClearIcon from '@mui/icons-material/Clear';

import AttendanceInfo from './info';
import AttendanceDetails from './attendanceDetails';

const durationPulgin = require('dayjs/plugin/duration')
dayjs.extend(durationPulgin)
const API_HOST = CONFIG.modules['accounts'].host



const items = {
    'Attendance': {
        name: 'Attendance',
        view: ''
    },

}

const fields = [
    {
        type: 'text',
        label: 'Employee Name',
        required: true,
        name: 'name'
    },
    {
        type: 'text',
        label: 'Email',
        required: true,
        name: 'email'
    },
    {
        type: 'text',
        label: 'Phone',
        required: true,
        name: 'phone'
    },
    {
        type: 'password',
        label: 'Password',
        required: true,
        name: 'password'
    },
    {
        type: 'group',
        items: [
            {
                type: 'date',
                label: 'Date of Birth',
                required: true,
                name: 'dob',
                defaultValue: dayjs('2022-04-17')
            },
            {
                type: 'date',
                label: 'Date of Joining',
                required: true,
                name: 'dateOfJoining',
                defaultValue: dayjs('2022-04-17')
            },
        ]
    },
    {
        type: 'select',
        label: 'Roles',
        required: true,
        name: 'roles',
        multiple: true,
        option: { key: 'roles', value: '_id', label: 'name' }

    },

    {
        type: 'select',
        label: 'Designation',
        option: { key: 'Designations', value: '_id', label: 'name' },
        required: true,
        name: 'designation',
        multiple: true
    },
    {
        type: 'select',
        label: 'Departments',
        option: { key: 'Departments', value: '_id', label: 'name' },
        required: true,
        name: 'departments',
        multiple: true
    },
    {
        type: 'select',
        label: 'Languages',
        option: { key: 'Languages', value: '_id', label: 'name' },
        name: 'languages',
        multiple: true
    },
    {
        type: 'select',
        label: 'Districts',
        option: { key: 'Districts', value: '_id', label: 'name' },
        name: 'district'
    },
    {
        type: 'select',
        label: 'Reporting Manager',
        option: { key: 'users', value: '_id', label: 'name' },
        name: 'reportingManager'
    },
    {
        type: 'select',
        label: 'POC',
        option: { key: 'users', value: '_id', label: 'name' },
        name: 'pocForLeaves'
    },
]

export const WeekWise = (props) => {
    const { roles, user, users, Designations, Departments, Languages, Districts, map } = useSelector((state) => (state.user || {}))
    const userStore = useSelector((state) => (state.user || {}))

    const [active, setActive] = useState('Attendance')
    const [data, setData] = useState(users || [])
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('new')
    const [saved, setSaved] = useState(null);
    const [index, setIndex] = useState(null);
    const [openConfirm, setOpenConfirm] = useState(false)
    const [formData, setFormData] = useState(getFormState(fields))
    const [filter, setFilter] = useState({
        // date: dayjs()
        from: dayjs().add(-6, 'day'),
        to: dayjs()
    })
    const [anchorEl, setAnchorEl] = useState(null);
    const openP = Boolean(anchorEl);
    const [rangeData, setRangeData] = useState({});
    const [selected, setSelected] = useState(null)
    const [dates, setDates] = useState([])
    const [attendanceMap, setAttendanceMap] = useState({})

    const [openDetals, setOpenDetails] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null)
    const [attendanceByUser, setAttendanceByUser] = useState({})


    const exportDataByUser = () => {
        axios.get(API_HOST + `/export-attendance-by-user?user=${selected._id}&from=${encodeURIComponent(dayjs(rangeData.from).format('YYYY-MM-DD'))}&to=${encodeURIComponent(dayjs(rangeData.to).format('YYYY-MM-DD'))}`, {
            responseType: 'arraybuffer'
        }).then((resp) => {
            if (resp) {
                const url = window.URL.createObjectURL(new Blob([resp.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Attendance_Report_${selected.name}.xlsx`);
                document.body.appendChild(link);
                link.click();
                console.log(resp)
                link.remove()
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    useEffect(() => {
        if (data) {
            setAttendanceMap(data.reduce((a, e) => {
                a[`${e.user?._id}-${dayjs(e.forDate).format('DD-MM-YYYY')}`] = e.status
                return a;
            }, {}))
        }
    }, [data])

    useEffect(() => {
    }, [attendanceMap])

    const fetchAttendanceUser = (user) => {

        axios.get(API_HOST + '/get-attendances-by-range-user?from=' + encodeURIComponent(dayjs(filter.from).format('YYYY-MM-DD')) + `&to=${encodeURIComponent(dayjs(filter.to).format('YYYY-MM-DD'))}&user=${user}`).then((resp) => {
            if (resp.data && resp.data.success) {
                setAttendanceByUser(resp.data.data.reduce((a, e) => {
                    a[dayjs(e.forDate).format('DD-MM-YYYY')] = e;
                    return a
                }, {}))
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    const fetchAttendance = () => {
        setData([])
        axios.get(API_HOST + '/get-attendance-by-range?from=' + encodeURIComponent(dayjs(filter.from).format('YYYY-MM-DD')) + `&to=${encodeURIComponent(dayjs(filter.to).format('YYYY-MM-DD'))}`).then((resp) => {
            if (resp.data && resp.data.success) {
                setData(resp.data.data.map((u) => {
                    u.name = map.users[u.user]?.name
                    u.user = map.users[u.user]
                    return u
                }))
            }
        }).catch((e) => {
            console.log(e)
        })
    }
    useEffect(() => {
        if (filter.from) {
            // const diff = dayjs(dayjs(filter.to).format('DD-MM-YYYY')).diff(dayjs(dayjs(filter.from).format('DD-MM-YYYY')))
            // if(diff>6) {
            //     // setFilter({...filter, to: dayjs(dayjs(filter.from).format('DD-MM-YYYY')).add(6, 'day') })
            // }
            // setFilter({...filter, to:filter.from})
        }
    }, [filter.from])

    useEffect(() => {
        if (filter.from && filter.to) {
            const dds = []
            let current = dayjs(filter.from);
            let i = 0;
            while (true) {
                dds.push(current.format('DD-MM-YYYY'))

                if (current.format('DD-MM-YYYY') == dayjs(filter.to).format('DD-MM-YYYY')) {
                    break;
                }
                i++
                if (i > 1000) {
                    break;
                }
                current = current.add(1, 'day')

            }
            console.log(dds)
            setDates(dds)
        }

    }, [filter])

    useEffect(() => {
        fetchAttendance()
    }, [filter])

    useEffect(() => {
        fetchAttendance()
    }, [active])

    useEffect(() => {
    }, [Designations])

    useEffect(() => {
    }, [userStore])

    const handleSubmit = () => {
        axios.post(API_HOST, {
            user: { ...formData }
        }).then((resp) => {
            if (resp.data && resp.data.success) {
                setOpen(false)
                setData([resp.data.data, ...data])
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    const handleEdit = () => {
        if (formData.password == '') {
            delete formData.password
        }
        axios.put(API_HOST + `/${saved._id}`, {
            user: formData
        }).then((resp) => {
            if (resp.data && resp.data.success) {
                setOpen(false)
                data[index] = resp.data.user
                setData([...data])
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    const handleDelete = () => {
        axios.delete(API_HOST + '/' + saved._id).then((resp) => {
            if (resp.data && resp.data.success) {
                setOpenConfirm(false)
                data.splice(index, 1)
                setData([...data])
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    const exportData = () => {
        axios.get(API_HOST + `/export-attendance?forDate=${encodeURIComponent(dayjs(filter.date).format('YYYY-MM-DD'))}`, {
            responseType: 'arraybuffer'
        }).then((resp) => {
            if (resp) {
                const url = window.URL.createObjectURL(new Blob([resp.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Attendance_Report_${dayjs(filter.date || new Date()).format('DD-MM-YYYY')}.xlsx`);
                document.body.appendChild(link);
                link.click();
                console.log(resp)
                link.remove()
            }
        }).catch((e) => {
            console.log(e)
        })
    }
    return (
        <>
            {/* <Tabs items={items} active={active} onChange={(key) => {
                setActive(key)
            }} /> */}
            <ToolBar name={active} buttons={[
                {
                    name: 'Export',
                    // type: 'chip',
                    icon: () => <IosShareIcon sx={{ fontSize: '1.2em' }} />,
                    onClick: () => {
                        exportData()
                    }
                }
            ]}



                filters={[
                    {
                        field: {
                            name: 'from',
                            type: 'date',
                            label: 'From',

                        },
                        onChange: (name, value) => {
                            filter[name] = value
                            setFilter({ ...filter })
                        },
                        state: filter

                    },
                    {
                        field: {
                            name: 'to',
                            type: 'date',
                            label: 'To',
                            shouldDisableDate: (d) => {
                                return (
                                    dayjs().isBefore(d)
                                );
                            },
                        },
                        onChange: (name, value) => {
                            filter[name] = value
                            setFilter({ ...filter })
                        },
                        state: filter

                    }
                ]} />

            <div>
                <AttendanceInfo type="week" filter={filter} />
            </div>

            <div>
                <Modal
                    open={openDetals}
                    styleA="md"
                    handleClose={() => {
                        setOpenDetails(false);
                    }}
                    head={`Monthly Report`}
                    buttons={[
                        {
                            name: "Cancel",
                            onClick: () => {
                                setOpenDetails(false);
                            },
                        },
                    ]}
                >
                    <>
                        <AttendanceDetails type="week" filter={filter} selectedUser={selectedUser} map={map} attendanceByUser={attendanceByUser} />
                    </>
                </Modal>
            </div>


            <Box sx={{ mt: 2 }}>
                {/* <Box sx={{width: '100%', overflow:'scroll', display: 'flex'}}> */}
                <Grid data={users.filter(u => !u.deleted)} columns={[
                    {
                        id: 'uuid', label: 'Employee Code', width: 130, format: (data, row) => {
                            return (
                                <Button
                                    variant='outlined'
                                    onClick={() => {
                                        setOpenDetails(true)
                                        setSelectedUser(row)
                                        fetchAttendanceUser(row._id)
                                    }}>
                                    {
                                        data || ''
                                    }
                                </Button>
                            )
                        }
                    },
                    { id: 'name', label: 'Employee Name', width: 170 },

                    ...(dates.length > 0 ? dates.map((d) => {
                        return {
                            id: '_id', width: 90, label: dayjs(d, 'DD-MM-YYYY').format('MMM DD'), format: (data, row) => {
                                return attendanceMap[`${data}-${d}`] == 'present' ? <CheckBoxIcon color="success" /> : <ClearIcon color="error" />
                            }
                        }

                    }) : []),

                    {
                        id: '_id', label: 'Action', minWidth: 70, format: (data, row) => {
                            return (
                                <Button onClick={(e) => {
                                    setSelected(row)
                                    setRangeData({
                                        from: dayjs(),
                                        to: dayjs(),
                                    });
                                    setAnchorEl(e.currentTarget);

                                }}>Report</Button>
                            )
                        }
                    }
                ]}

                ></Grid>
                {/* </Box> */}
            </Box>
            <Modal open={open}
                handleClose={() => { setOpen(false) }}
                head={`${action == 'new' ? 'Add' : 'Edit'} ${active}`}
                buttons={[
                    {
                        name: 'Cancel',
                        onClick: () => {
                            setOpen(false)
                        }
                    },
                    {
                        name: action == 'new' ? 'Create' : 'Save',
                        onClick: () => {
                            switch (action) {
                                case 'new':
                                    handleSubmit()
                                    break;
                                case 'edit':
                                    handleEdit()
                                    break;
                                default: break;
                            }
                        }
                    }
                ]}

            >
                {
                    action == 'edit' &&
                    <Typography variant='p' color="grey">{
                        'ID: ' + saved._id
                    }</Typography>
                }
                {
                    Array.isArray(fields) &&
                    <FormA fields={fields}
                        data={{ roles, Designations, Districts, Languages, Departments, users }}
                        onChange={(name, value, multiple) => {
                            formData[name] = value
                            setFormData({ ...formData })
                        }}
                        state={formData || {}}
                    />
                }


            </Modal>

            <Modal open={openConfirm}
                handleClose={() => { setOpen(false) }}
                head={`${'Delete'} ${active}`}
                desc={`Please confirm to delete the following ${active}?`}
                buttons={[
                    {
                        name: 'Cancel',
                        onClick: () => {
                            setOpenConfirm(false)
                        }
                    },
                    {
                        name: 'Delete',
                        onClick: () => {
                            handleDelete()
                        }
                    }
                ]}

            >
                {
                    saved &&
                    <Box>
                        <Typography variant='p' color="grey">{'ID: ' + saved._id}</Typography><br></br>
                        <Typography variant='p' color="grey">{'Name: ' + saved.name}</Typography>
                    </Box>
                }

            </Modal>

            <Popover
                id={"report-range"}
                open={openP}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                    vertical: "center",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <Box sx={{ padding: 2, borderRadius: 2 }}>
                    <FormA
                        fields={[
                            {
                                type: "date",
                                label: "From",
                                required: true,
                                name: "from",
                                defaultValue: dayjs(),
                                shouldDisableDate: (d) => {
                                    return (
                                        dayjs(d).isAfter(dayjs()) || dayjs(d).isAfter(rangeData.to)
                                    );
                                },
                            },
                            {
                                type: "date",
                                label: "To",
                                required: true,
                                name: "to",
                                defaultValue: dayjs(),
                                shouldDisableDate: (d) => {
                                    return (
                                        dayjs(d).isAfter(dayjs()) || dayjs(d).isBefore(rangeData.from)
                                    );
                                },
                            },
                        ]}
                        data={{}}
                        onChange={(name, value, multiple) => {
                            const newRange = { ...rangeData };
                            newRange[name] = dayjs(value);
                            setRangeData(newRange);
                        }}
                        state={rangeData}
                    />

                    <Button
                        onClick={() => {

                            exportDataByUser()
                        }}
                    >
                        {"Export"}
                    </Button>
                </Box>
            </Popover>
        </>
    )
}